import React from 'react';
import { LOOTBOX_RARITIES } from '../../constants/lootbox';
import ItemIcon from '../lootbox/ItemIcon';

function MyActivity({ myListings, myBids, listings, onCancelListing }) {
  return (
    <div className="my-activity-container">
      <div className="activity-section">
        <h3>My Listings ({myListings.length})</h3>
        {myListings.length === 0 ? (
          <p className="empty-text">No active listings</p>
        ) : (
          <div className="activity-list">
            {myListings.map(listing => {
              // Safety check
              if (!listing.item || !listing.item.rarity || !LOOTBOX_RARITIES[listing.item.rarity]) {
                console.error("Invalid listing item data:", listing);
                return null;
              }

              const rarity = LOOTBOX_RARITIES[listing.item.rarity];
              return (
                <div key={listing.id} className="activity-card">
                  <div className="activity-icon"><ItemIcon item={listing.item} size={48} /></div>
                  <div className="activity-info">
                    <div className="activity-name" style={{ color: rarity.color }}>
                      {listing.item.name || 'Unknown Item'}
                    </div>
                    <div className="activity-details">
                      {listing.auctionMode ? `Auction - Current: ${listing.currentBid || 0}` : `Buy Now - ${listing.price}`} 🪙
                    </div>
                    <div className="activity-status">{listing.status}</div>
                  </div>
                  {listing.status === "active" && (
                    <button
                      className="btn-cancel-small"
                      onClick={() => onCancelListing(listing.id)}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="activity-section">
        <h3>My Bids ({myBids.length})</h3>
        {myBids.length === 0 ? (
          <p className="empty-text">No active bids</p>
        ) : (
          <div className="activity-list">
            {myBids.map(bid => {
              const listing = listings.find(l => l.id === bid.listingId);
              if (!listing) return null;
              const rarity = LOOTBOX_RARITIES[listing.item.rarity];
              const isWinning = listing.highestBidder === bid.bidderId;

              return (
                <div key={bid.id} className="activity-card">
                  <div className="activity-icon"><ItemIcon item={listing.item} size={48} /></div>
                  <div className="activity-info">
                    <div className="activity-name" style={{ color: rarity.color }}>
                      {listing.item.name}
                    </div>
                    <div className="activity-details">
                      Your bid: {bid.bidAmount} 🪙
                    </div>
                    <div className={`activity-status ${isWinning ? 'winning' : 'outbid'}`}>
                      {isWinning ? '✅ Winning' : '❌ Outbid'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyActivity;
